import { render, staticRenderFns } from "./TripsCreateComponent.vue?vue&type=template&id=019b5b51&scoped=true"
import script from "./create.js?vue&type=script&lang=js&external"
export * from "./create.js?vue&type=script&lang=js&external"
import style0 from "./TripsCreateComponent.vue?vue&type=style&index=0&id=019b5b51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b5b51",
  null
  
)

export default component.exports